module.exports = __webpack_public_path__ + "static/media/m_eyeshape_monolid_grey.976c1e30.png";